<template>
  <v-flex v-if="show" :class="`xs12 ${classes} has-tooltip`">
    <v-text-field
      v-model="organizationServiceIdValue"
      placeholder="Letters, numbers, and - ( ) _"
      label="Organization Service ID"
      counter
      maxlength="50"
      :rules="[rules.counter, rules.format]"
    />
    <help-tooltip
      tooltip="This field will only be used in exports and will not show onscreen."
    />
  </v-flex>
</template>

<script>
import HelpTooltip from '../../shared/HelpTooltip'

export default {
  components: {
    HelpTooltip,
  },
  computed: {
    organizationServiceIdValue: {
      get() {
        return this.organizationServiceId
      },
      set(value) {
        this.$emit('update:organizationServiceId', value)
      },
    },
  },
  data() {
    return {
      rules: {
        counter: (value) => value.length <= 50 || 'Max 50 characters',
        format: (value) =>
          value.match(/^[a-zA-Z0-9-_()]*$/) ||
          'Allowed characters: letters, numbers, and - ( ) _',
      },
    }
  },
  props: ['show', 'organizationServiceId', 'classes'],
}
</script>
